import { render, staticRenderFns } from "./streets_test.vue?vue&type=template&id=91094f06&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./streets_test.vue?vue&type=script&lang=js"
export * from "./streets_test.vue?vue&type=script&lang=js"
import style0 from "./streets_test.vue?vue&type=style&index=0&id=91094f06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91094f06",
  null
  
)

export default component.exports